import {Reducer} from "redux";
import { ClientSalesCampaignAction, ClientSalesCampaignActionType, ICallbackGetCustomerByClientSalesCampaignPageAction} from "../action/client_sales_campaign";
import { ClientSalesCampaignState } from "../store/client_sales_campaign_store";

const initialState: ClientSalesCampaignState = {
    salesStrategyCustomers: [],
    cooCustomers: [],
    kpiCustomers: [],
    partnerSalesCustomers: [],
    allianceCustomers: [],
    salesOrgDevCustomers: [],
    sfaCrmCustomers: [],
    salesEnablementCustomers: [],
    salesDxCustomers: [],
    insideSalesCustomers: [],
    customerSuccessCustomers: [],
    ltvCustomers: [],
    groupSalesCustomers: [],
    interDeptCustomers: [],
    crossSellCustomers: [],
    jobCareersWithCustomerID: [],
    clientBookmarks: [],
    isLoading: false,
};

const clientSalesCampaignReducer: Reducer<ClientSalesCampaignState> = (state = initialState, action: ClientSalesCampaignAction): ClientSalesCampaignState => {
    switch (action.type) {

        case ClientSalesCampaignActionType.REQUEST_GET_CUSTOMERS: {
            return Object.assign({}, state, {
                isLoading: true,
            });
        }
        case ClientSalesCampaignActionType.CALLBACK_GET_CUSTOMERS: {
            const _action = action as ICallbackGetCustomerByClientSalesCampaignPageAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    salesStrategyCustomers: (_action.item) ? _action.item.salesStrategyCustomers : [],
                    cooCustomers: (_action.item) ? _action.item.cooCustomers : [],
                    kpiCustomers: (_action.item) ? _action.item.kpiCustomers : [],
                    partnerSalesCustomers: (_action.item) ? _action.item.partnerSalesCustomers : [],
                    allianceCustomers: (_action.item) ? _action.item.allianceCustomers : [],
                    salesOrgDevCustomers: (_action.item) ? _action.item.salesOrgDevCustomers : [],
                    sfaCrmCustomers: (_action.item) ? _action.item.sfaCrmCustomers : [],
                    salesEnablementCustomers: (_action.item) ? _action.item.salesEnablementCustomers : [],
                    salesDxCustomers: (_action.item) ? _action.item.salesDxCustomers : [],
                    insideSalesCustomers: (_action.item) ? _action.item.insideSalesCustomers : [],
                    customerSuccessCustomers: (_action.item) ? _action.item.customerSuccessCustomers : [],
                    ltvCustomers: (_action.item) ? _action.item.ltvCustomers : [],
                    groupSalesCustomers: (_action.item) ? _action.item.groupSalesCustomers : [],
                    interDeptCustomers: (_action.item) ? _action.item.interDeptCustomers : [],
                    crossSellCustomers: (_action.item) ? _action.item.crossSellCustomers : [],
                    jobCareersWithCustomerID: (_action.item) ? _action.item.jobCareersWithCustomerID : [],
                    clientBookmarks: (_action.item) ? _action.item.clientBookmarks : [],
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            }
        }

        default:
            return state;
    }
};

export default clientSalesCampaignReducer;



// WEBPACK FOOTER //
// ./src/presentation/reducer/client_sales_campaign_reducer.ts